// extracted by mini-css-extract-plugin
export default {"content":"WithdrawnModal_content__pi73p","description":"WithdrawnModal_description__zxTuq"};